import { colorsPalettes } from "@similarweb/styles";
import type { StrictColor } from "@similarweb/styles";

export const similarwebValueType = {
    Text: "Text",
    Number: "Number",
    Percent: "Percent",
    Range: "Range",
    Date: "Date",
    List: "List",
    Duration: "Duration",
} as const;

export type SimilarwebValueType = (typeof similarwebValueType)[keyof typeof similarwebValueType];

export const VALUE_TYPE_I18N_KEY: Record<SimilarwebValueType, string> = {
    Text: "si.management.integration.export.value_type.text",
    Number: "si.management.integration.export.value_type.number",
    Percent: "si.management.integration.export.value_type.percent",
    Range: "si.management.integration.export.value_type.range",
    Date: "si.management.integration.export.value_type.date",
    List: "si.management.integration.export.value_type.list",
    Duration: "si.management.integration.export.value_type.duration",
};

export const VALUE_TYPE_BADGE_COLORS: Record<SimilarwebValueType, { bgColor: StrictColor; color: StrictColor }> = {
    Text: { bgColor: colorsPalettes.indigo[50], color: colorsPalettes.indigo[400] },
    Number: { bgColor: colorsPalettes.mint[50], color: colorsPalettes.mint[500] },
    Percent: { bgColor: colorsPalettes.pink[100], color: colorsPalettes.pink[400] },
    Range: { bgColor: colorsPalettes.yellow[100], color: colorsPalettes.yellow[600] },
    Date: { bgColor: colorsPalettes.purple[50], color: colorsPalettes.purple[400] },
    List: { bgColor: colorsPalettes.carbon[50], color: colorsPalettes.carbon[400] },
    Duration: { bgColor: colorsPalettes.brown[100], color: colorsPalettes.brown[500] },
};
